import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface CollegeState {
  collegeData: any;
  leadershipTab: string;
  safeInclusiveTab: string;
  contantWeatherTab: string;
  subScreen: string;
  visible: boolean;
  images: string[];
  activeIndex: number;
  containerVisible: boolean;
  containerImages: any[];
  containerActiveIndex: number;
  rankingData: any[];
  similarCollegeList: any[];
  sponsoredCollegeList: any[];
  isLoading: boolean;
  courseDetails: any[];
  shortListData: any[];
  brochure: string;
  virtualTour: string;
  skipSimilarCollege: number;
  hasMoreSimilarCollege: boolean;
  isLoadingSimilarCollege: boolean;
  ratingValue: number;
}

const initialState: CollegeState = {
  collegeData: null,
  leadershipTab: 'sports',
  safeInclusiveTab: 'safety',
  contantWeatherTab: 'contact',
  subScreen: '',
  visible: false,
  images: [],
  activeIndex: 0,
  containerVisible: false,
  containerImages: [],
  containerActiveIndex: 0,
  rankingData: [],
  similarCollegeList: [],
  sponsoredCollegeList: [],
  shortListData: [],
  isLoading: false,
  courseDetails: [],
  brochure: "",
  virtualTour: "",
  skipSimilarCollege: 0,
  hasMoreSimilarCollege: true,
  isLoadingSimilarCollege: false,
  ratingValue:1,
};

const collegeDetailsSlice = createSlice({
  name: 'collegeDetails',
  initialState,
  reducers: {
    setCollegeData(state, action: PayloadAction<any>) {
      state.collegeData = action.payload;
    },
    setLoading(state, action: PayloadAction<boolean>) {
      state.isLoading = action.payload;
    },
    updateCollegeData(state, action: PayloadAction<{ key: string; value: any }>) {
      if (state.collegeData) {
        state.collegeData[action.payload.key] = action.payload.value;
      }
    },
    setLeadershipTab(state, action: PayloadAction<string>) {
      state.leadershipTab = action.payload;
    },
    setSafeInclusiveTab(state, action: PayloadAction<string>) {
      state.safeInclusiveTab = action.payload;
    },
    setContantWeatherTab(state, action: PayloadAction<string>) {
      state.contantWeatherTab = action.payload;
    },
    setSubScreen(state, action: PayloadAction<string>) {
      state.subScreen = action.payload;
    },
    openCarousel: (state, action: PayloadAction<{ images: string[], index: number }>) => {
      state.visible = true;
      state.images = action.payload.images;
      state.activeIndex = action.payload.index;
    },
    closeCarousel: (state) => {
      state.visible = false;
    },
    setActiveIndex: (state, action: PayloadAction<number>) => {
      state.activeIndex = action.payload;
    },
    openContainerCarousel: (state, action: PayloadAction<{ data: any[], index: number }>) => {
      state.containerVisible = true;
      state.containerImages = action.payload.data;
      state.containerActiveIndex = action.payload.index;
    },
    closeConatinerCarousel: (state) => {
      state.containerVisible = false;
    },
    setConatinerActiveIndex: (state, action: PayloadAction<number>) => {
      state.containerActiveIndex = action.payload;
    },
    setRankingData(state, action: PayloadAction<any>) {
      state.rankingData = action.payload;
    },
    setSimilarCollege(state, action: PayloadAction<any>) {
      state.similarCollegeList = action.payload;
    },
    setSponsoredCollege(state, action: PayloadAction<any>) {
      state.sponsoredCollegeList = action.payload;
    },
    setCourseDetails(state, action: PayloadAction<any>) {
      state.courseDetails = action.payload;
    },
    setCollegeShortlistData: (state, action) => {
      state.shortListData = action.payload;
    },
    setBrochure: (state, action: PayloadAction<string>) => {
      state.brochure = action.payload;
    },
    setVirtualTour: (state, action: PayloadAction<string>)=>{
      state.virtualTour = action.payload;
    },
    setSkipSimilarCollege: (state, action) => {
      state.skipSimilarCollege = action.payload;
    },
    setHasMoreSimilarCollege: (state, action) => {
      state.hasMoreSimilarCollege = action.payload;
    },
    setIsLoadingSimilarCollege: (state, action) => {
      state.isLoadingSimilarCollege = action.payload;
    },
    setRatingvalue: (state, action)=>{
      state.ratingValue = action.payload;
    },

    clearCollegeDetailsState: () => initialState,
  },
});

export const { setCollegeData,
  setLeadershipTab,
  setSafeInclusiveTab,
  setContantWeatherTab,
  setSubScreen,
  setActiveIndex,
  closeCarousel,
  openCarousel,
  openContainerCarousel,
  closeConatinerCarousel,
  setConatinerActiveIndex,
  setRankingData,
  updateCollegeData,
  setBrochure,
  setVirtualTour,
  setSimilarCollege,
  setSponsoredCollege,
  setLoading,
  setCourseDetails,
  setCollegeShortlistData,
  setSkipSimilarCollege,
  setHasMoreSimilarCollege,
  setIsLoadingSimilarCollege,
  setRatingvalue,
  clearCollegeDetailsState
} = collegeDetailsSlice.actions;
export default collegeDetailsSlice.reducer;
